import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useLoading } from '../../context/LoadingContext';
import { authService } from '../../services/authService';
import { setAuthToken } from '../../services/api';
import { setAccessToken } from '../../services/tokenService';

const AuthInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { setIsLoading } = useLoading();
  const { login } = useAuth();

  useEffect(() => {
    const initialize = async () => {
      const token = await authService.silentRefresh();
      if (token) {
        setAccessToken(token);
        setAuthToken(token);
        login(token);
      }
      setIsLoading(false);
    };

    initialize();
  }, [setIsLoading, login]);

  return <>{children}</>;
};

export default AuthInitializer;